// extracted by mini-css-extract-plugin
export default {"report-status":"ReportStatus_report-status__XrLkk","report-status-loading-icon":"ReportStatus_report-status-loading-icon__9qzCg","spin":"ReportStatus_spin__WkcIs"};